import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getRevenueDashData({ commit, state }, { params }) {
    return axios
      .get(`v1/dashboard/`, {
        params: params,
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getReports({ commit, state }, { params }) {
    return axios
      .get(`v1/dashboard/report`, {
        params: params,
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  insertDashboard({ commit, state }, { dashboardCountObject }) {
    return axios
      .post(`v1/dashboard/dashboardCount`, dashboardCountObject)
      .then(response => {
        return response.data
      })
  },
}
